import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from "../../config";

function UpdateMediaDetail() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [media, setMedia] = useState({
        title: "",
        link: "",
    });

    const [mediaFile, setMediaFile] = useState(null);
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const mediaFileRef = useRef(null);

    useEffect(() => {
        const fetchMediaDetails = async () => {
            try {
                const response = await axios.get(
                    `${config.BASE_URL}/api/admin/get-media/${id}`,
                    { withCredentials: true }
                );

                setMedia(response.data);
            } catch (err) {
                setError("Failed to fetch media details");
            }
        };

        fetchMediaDetails();
    }, [id]);

    const handleRemoveFile = async () => {
        try {
            const response = await axios.post(
                `${config.BASE_URL}/api/admin/remove-media-file`,
                {
                    mediaId: media._id,
                },
                { withCredentials: true }
            );

            if (response.status === 200) {
                setMedia((prev) => ({
                    ...prev,
                    mediafile: "",
                }));
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleMediaFileChange = (e) => {
        setMediaFile(e.target.files[0]);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append("title", media.title);
        formData.append("link", media.link);

        if (mediaFile) {
            formData.append("mediafile", mediaFile);
        }

        try {
            const response = await axios.put(
                `${config.BASE_URL}/api/admin/update-media/${id}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    withCredentials: true,
                }
            );

            setMedia(response.data.media);

            if (mediaFileRef.current) {
                mediaFileRef.current.value = "";
            }

            setMediaFile(null);
            setSuccessMessage("Media updated successfully!");
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
        } catch (err) {
            // setError("Failed to update media");
            setError(
                err?.response?.data?.message || "Failed to update media"
            );
            setTimeout(() => {
                setError("");
            }, 3000);
            //  setError(response?.data?.message);

        }
    };

    const isVideo =
        media?.mediafile &&
        /\.(mp4|webm|mov|avi)$/i.test(media.mediafile);

    return (
        <div className="dashboard update_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Edit Media</h1>

                <div className="back_btn_wrap">
                    <button
                        className="back-btn"
                        onClick={() => navigate(-1)}
                    >
                        Go Back
                    </button>
                </div>

                {media ? (
                    <form
                        onSubmit={handleFormSubmit}
                        encType="multipart/form-data"
                    >
                        <div className="update_details_wrap">

                            <div className="form-group">
                                <label>Media Title</label>
                                <input
                                    type="text"
                                    value={media.title}
                                    onChange={(e) =>
                                        setMedia({
                                            ...media,
                                            title: e.target.value,
                                        })
                                    }
                                />
                            </div>

                            <div className="form-group">
                                <label>Video Link</label>
                                <input
                                    type="url"
                                    value={media.link}
                                    onChange={(e) =>
                                        setMedia({
                                            ...media,
                                            link: e.target.value,
                                        })
                                    }
                                />
                            </div>

                            <div className="form-group">
                                <label>Media File</label>

                                <input
                                    type="file"
                                    onChange={handleMediaFileChange}
                                    ref={mediaFileRef}
                                />
                            </div>

                            <div className="form-group">
                                {media.mediafile ? (
                                    <div className="detail_img_item">

                                        {isVideo ? (
                                            <video
                                                controls
                                                width="400"
                                            >
                                                <source
                                                    src={`${config.BASE_URL}${media.mediafile}`}
                                                />
                                            </video>
                                        ) : (
                                            <img
                                                src={`${config.BASE_URL}${media.mediafile}`}
                                                alt={media.title}
                                                width="300"
                                            />
                                        )}

                                        <button
                                            className="remove_btn"
                                            type="button"
                                            onClick={handleRemoveFile}
                                        >
                                            Remove File
                                        </button>
                                    </div>
                                ) : (
                                    <p>No media file available.</p>
                                )}
                            </div>

                            <div className="update_btn_wrap">
                                <button
                                    className="update_btn"
                                    type="submit"
                                >
                                    Update Media
                                </button>
                            </div>

                            {successMessage && (
                                <p className="success-message">
                                    {successMessage}
                                </p>
                            )}

                            {error && (
                                <p className="error-message">
                                    {error}
                                </p>
                            )}
                        </div>
                    </form>
                ) : (
                    <h5>Media not found!</h5>
                )}
            </div>
        </div>
    );
}

export default UpdateMediaDetail;